// TODO: Port from Next.js app
import { ConversationPriorityState } from '@/lib/priority/types';

export function getFlowContextFromPriorityState(
  priorityState: ConversationPriorityState,
  lastMessageDate: Date
) {
  return {
    currentStep: 'idle',
    flowNameKey: 'flowBuilder.flows.booking',
  };
}
